import { render } from "./EditChefquartierPage.vue?vue&type=template&id=7c9346a4&ts=true"
import script from "./EditChefquartierPage.vue?vue&type=script&lang=ts"
export * from "./EditChefquartierPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__